// extracted by mini-css-extract-plugin
export var columnList = "_gi-0";